export default {
    disabled: {
        title: 'Feature not enabled',
        description: 'This feature is not enabled for your organization.',
    },
    header: {
        title: 'My employee portal',
        subtitle:
            'You are the driver of your own success. Explore your strengths, your growth opportunities and your objectives',
    },
    loadError: 'Your portal could not be loaded. Try again.',
    retry: 'Retry',
    viewingPortal: {
        named: 'You are viewing {{name}}’s portal, exactly as they see it.',
        unnamed: 'You are viewing an employee’s portal, exactly as they see it.',
        withheldLevels:
            'Their levels are withheld from them until your meeting, so they are withheld here too.',
    },
    viewPortal: {
        label: 'View portal',
        own: 'Your portal',
        search: 'Search for an employee',
        noMatch: 'No employee matches your search.',
        none: 'No employee to show',
        loadError: 'List unavailable',
    },
    tabs: {
        ariaLabel: 'Performance portal sections',
        summary: 'Summary',
        objectives: 'Objectives',
    },
    noTabs: {
        title: 'Nothing to show yet',
        description: 'Your organization has not enabled any section of this portal.',
    },
    comingSoon: 'This section will be available soon.',
    objectives: {
        hero: {
            badge: 'Your objectives',
            title: 'Your objectives contribute to {{company}}',
            titleWithoutCompany: 'Your objectives contribute to the organization',
            subtitle:
                "Track your progress, celebrate the milestones you reach and see how your objectives fuel the organization's strategy.",
            overallProgression: 'Overall progression',
            inProgressCount_one: '{{count}} objective in progress',
            inProgressCount_other: '{{count}} objectives in progress',
            accomplished: 'Objectives achieved',
        },
        pillars: {
            title: "Where the organization's pillars stand",
            subtitle:
                'Each pillar counts the objectives of the whole organization. "{{badge}}" marks the ones your objectives feed.',
            progression: 'Organization progress',
            contributing: 'You contribute here',
            loadError: 'The strategic pillars could not be loaded.',
        },
        list: {
            title: 'Your objectives',
            subtitle: 'View and track your strategic objectives',
            empty: 'You have no objective in this period.',
            loadError: 'Your objectives could not be loaded.',
        },
    },
};
